/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import React from "react"
import Home from "pages/home"
import Facility from "pages/facility"
import TenantDetail from "pages/tenant"

// @mui icons
import Icon from "@mui/material/Icon"
import Login from "pages/login"
import AuthCode from "pages/auth-code"
import ResetPassword from "pages/reset-password"
import Lock from "pages/lock"
import InitializePassword from "pages/initialize-password"

// データ登録関連画面
import ManageAccount from "pages/manage/account"
import ManageCatv from "pages/manage/catv"
import ManageEstate from "pages/manage/estate"
import ManageFacility from "pages/manage/facility"
import ManageDevice from "pages/manage/device"
import ManageLog from "pages/manage/life-log"
import ManagePage from "pages/manage/manage"
import ManageEstateMail from "pages/manage/estate_mail"
import DetectSettingPage from "pages/manage/detect_setting"
import DataImportPage from "pages/manage/data_import"
import ManageSensitivitySetting from "pages/manage/sensitivity_setting"

export interface RouteType {
  type: "collapse" | "title" | "divider" | "home" | "data" | "hidden" | "help" | "log" | "manage"
  name: string
  key: string
  icon?: React.ReactNode
  route?: string
  component?: React.ReactNode
  collapse?: RouteType[]
}

const routes: RouteType[] = [
  {
    type: "home",
    name: "ホーム",
    key: "home",
    icon: <Icon fontSize="small">home</Icon>,
    route: "/home",
    component: <Home />
  },
  {
    type: "data",
    name: "データ登録",
    key: "data",
    icon: <Icon fontSize="small">storage</Icon>,
    route: "/data",
    component: <Home />
  },
  {
    type: "hidden",
    name: "アカウント",
    key: "manage_account",
    route: "/manage_account",
    component: <ManageAccount />
  },
  {
    type: "hidden",
    name: "サービス提供元",
    key: "manage_catv",
    route: "/manage_catv",
    component: <ManageCatv />
  },
  {
    type: "hidden",
    name: "不動産業者",
    key: "manage_estate",
    route: "/manage_estate",
    component: <ManageEstate />
  },
  {
    type: "hidden",
    name: "施設管理",
    key: "manage_facility",
    route: "/manage_facility",
    component: <ManageFacility />
  },
  {
    type: "hidden",
    name: "デバイス",
    key: "manage_device",
    route: "/manage_device",
    component: <ManageDevice />
  },
  {
    type: "hidden",
    name: "検知メール送信先",
    key: "manage_estate_mail",
    route: "/manage_estate_mail",
    component: <ManageEstateMail />
  },
  {
    type: "hidden",
    name: "検知設定",
    key: "manage_detect_setting",
    icon: <Icon fontSize="small">settings</Icon>,
    route: "/manage_detect_setting",
    component: <DetectSettingPage />
  },
  {
    type: "hidden",
    name: "感度設定",
    key: "manage_sensitivity_setting",
    icon: <Icon fontSize="small">tune</Icon>,
    route: "/manage_sensitivity_setting",
    component: <ManageSensitivitySetting />
  },
  {
    type: "help",
    name: "ヘルプ",
    key: "help",
    icon: <Icon fontSize="small">help</Icon>
  },
  {
    type: "log",
    name: "ログ",
    key: "life-log",
    icon: <Icon fontSize="small">assignment</Icon>,
    route: "/life-log",
    component: <ManageLog />
  },
  {
    type: "manage",
    name: "管理",
    key: "manage",
    icon: <Icon fontSize="small">settings</Icon>,
    route: "/manage",
    component: <ManagePage />
  },
  {
    type: "hidden",
    name: "初期データ登録",
    key: "data_import",
    icon: <Icon fontSize="small">settings</Icon>,
    route: "/data_import",
    component: <DataImportPage />
  },
  {
    type: "hidden",
    name: "(施設詳細直リンク)",
    key: "facility-detail",
    route: "/facility/:id",
    component: <Facility />
  },
  {
    type: "hidden",
    name: "(入居者詳細直リンク)",
    key: "tenant-detail",
    route: "/tenant/:facility_id/:medical_record_id",
    component: <TenantDetail />
  },
  {
    type: "hidden",
    name: "(ログイン)",
    key: "login",
    route: "/login",
    component: <Login />
  },
  {
    type: "hidden",
    name: "(認証コード)",
    key: "auth-code",
    route: "/auth-code",
    component: <AuthCode />
  },
  {
    type: "hidden",
    name: "(パスワード忘れ)",
    key: "reset-password",
    route: "/reset-password",
    component: <ResetPassword />
  },
  {
    type: "hidden",
    name: "(アカウントロック)",
    key: "lock",
    route: "/lock",
    component: <Lock />
  },
  {
    type: "hidden",
    name: "(初期パスワード入力)",
    key: "initialize-password",
    route: "/initialize-password",
    component: <InitializePassword />
  }
]

export default routes
